<template lang="pug">
.columns.is-vcentered.is-gapless.has-background-light
  .column.is-one-half
    figure.image
      prismic-image.member-photo(:field="member.image")
  .column.is-one-half
    .content.p-1
      p.title.is-4 {{ member.name }}
      p.subtitle.is-6 {{ member.hometown }}
      p.subtitle.is-6 {{ member.university }}
      .columns
        .column.is-narrow
          p.is-size-7.has-text-weight-medium Fan of
        .column.is-narrow
          p.subtitle.is-7(v-for="item in member.fan") {{ item.label[0].text }}
      .columns
        .column.is-narrow(v-if="member.email.length")
          b-button(type="is-info", tag="a", :href="'mailto:' + member.email")
            font-awesome-icon(:icon="['fas', 'envelope']")
            span  Email
        .column.is-narrow(v-if="member.instagram")
          b-button(type="is-dark", tag="a", :href="'https://instagram.com/' + member.instagram", target="_blank")
            font-awesome-icon(:icon="['fab', 'instagram']")
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

library.add(faEnvelope, faInstagram);

export default {
  name: "TeamMember",

  props: ["member"]
};
</script>

<style lang="scss" scoped>
.member-photo {
  position: relative;
  z-index: 0;
}

.logo-icon {
  border-radius: 50%;
  padding: 8px;
  background: white;
}

.grow {
  transition: all 0.2s ease-in-out;
}

.grow:hover {
  transform: scale(1.1);
}
</style>
